import {Component, OnDestroy, OnInit} from '@angular/core';
import {downgradeComponent} from '@angular/upgrade/static';
import * as angular from 'angular';
import {GLOBAL_NOTIFICATION_TYPE, GlobalNotification, GlobalNotificationsService} from './global-notifications.service';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import {filter} from 'lodash';

@Component({
	selector: 'tt-global-notifications',
	templateUrl: 'global-notifications.component.html',
	styleUrls: ['global-notifications.component.scss']
})
export class GlobalNotificationsComponent implements  OnInit, OnDestroy {
	public NOTIFICATION_TYPE: any = GLOBAL_NOTIFICATION_TYPE;
	public notifications: GlobalNotification[] = [];
	private destroy$: Subject<void> = new Subject<void>();

	constructor(
		private globalNotificationsService: GlobalNotificationsService
	) {

	}

	ngOnInit(): void {
		const self: GlobalNotificationsComponent = this;
		this.globalNotificationsService.onNewNotification()
			.takeUntil(this.destroy$)
			.subscribe((notification: GlobalNotification) => {
				if (notification.hideIn) {
					setTimeout(() => {
						self.closeNotification(notification.id);
					}, notification.hideIn);
				}
				this.notifications.push(notification);
			});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
	}

	public closeNotification(id: number): void {
		this.notifications = filter(this.notifications, (notification: GlobalNotification) => {
			return notification.id !== id;
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/core/components/global-notifications/global-notifications.component.ts